<template lang="html">

  <article class="receta-el -backgroundLoad">

    <template v-if="!fake">

      <span class="background" :style="`background:url(${data.header_img.url}) center/cover no-repeat`"></span>

      <div class="contenedor-categorias row-start">

        <span :to="$t('enlaces.recetas')+'#'+categoria.slug" v-for="(categoria,key) in data.category" :key="key">{{categoria.name}}</span>

      </div>

      <div class="contenedor-texto">

        <p v-html="data.name"></p>

        <span class="more">+</span>

        <aside class="stats row-start ais">

          <p class="row-start" title="Tiempo de preparación">
            <img src="/static/img/icon-tiempo.svg" alt="Tiempo necesario" title="Tiempo de preparacion">
            {{data.time | setTime}}
          </p>
          <p class="row-start" title="Dificultad">
            <img src="/static/img/icon-dificultad.svg" alt="Dificultad" title="Dificultad">
            {{$t(`recetas.dificultad[${data.dificulty}]`)}}
          </p>
          <p class="row-start" title="Raciones">
            <img src="/static/img/icon-comensales.svg" alt="Comensales" title="Raciones">
            {{data.portions}}
          </p>

        </aside>

      </div>

      <router-link :to="$t('enlaces.recetas')+'/'+data.slug" class="enlace-cover"></router-link>

    </template>

  </article>

</template>

<script lang="js">
  
  import {mapGetters} from 'vuex';

  export default  {
    name: 'receta-el',
    props: ['data', 'fake'],
    filters : {
      setTime : function(value){
        return value + "'";
      }
    },
    computed : {
      ...mapGetters(['getServer'])
    }
  }
</script>

<style scoped lang="scss">
.receta-el {
  width: calc(33.33333% - 10px);
  height: 300px;
  display: inline-block;
  position: relative;
  margin-right: 15px;
  margin-bottom: 30px;
  overflow: hidden;
}

.receta-el p{
  font-size: 16px;
  line-height: 20px;
}

.receta-el:nth-child(3n){
  margin-right: 0;
}

.contenedor-categorias{
  position: absolute;
  left: 0;
  top:0;
  padding: 10px;
  width: 100%;
}

.contenedor-categorias span{
  z-index: 6;
  position: relative;
  padding: 5px;
  color: #fff;
  background: #967842;
  font-size: 13px;
  margin-bottom: 10px;
  margin-right: 10px;
}

.contenedor-categorias span:last-of-type{
  margin-right: 0;
}

.contenedor-texto{
  position: absolute;
  left: 0;
  bottom: 0;
  background: rgba(255,255,255,.9);
  padding: 10px 10px 50px 10px;
  text-align: left;
  color: #202C54;
  width: 100%;
  min-height: 100px;
}

.contenedor-texto .more{
  position: absolute;
  right: 0;
  bottom: 0;
  width: 50px;
  height: 50px;
  line-height: 50px;
  font-size: 40px;
  color: #fff;
  background: #202C54;
  font-weight: 300;
  text-align: center;
  z-index: 2;
}

.background{
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: inline-block;
  transition: 1s;
}


.receta-el:hover .background{
  transform: scale(1.1);
}


.stats{
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  padding:10px 50px 5px 10px;
  -ms-align-items: stretch;
  align-items: stretch;
  -webkit-align-items: stretch;
  z-index: 6;
  cursor: pointer;
  pointer-events: none;
}

.stats p{
  margin-bottom: 0;
  padding-right: 20px;
  cursor:pointer;
  pointer-events: visible;
}

.stats p img{
  margin-right: 5px;
  max-width: 18px;
}

@media screen and (max-width: 1023px){

  .receta-el{
    width: calc(50% - 10px);
    margin-right: 0px;
  }

  .receta-el:nth-child(2n){
    margin-left: 20px;
  }

  .receta-el:nth-child(3n){
    margin-right: 0;
  }

    .contenedor-texto .more{
    width: 30px;
    line-height: 30px;
    height: 30px;
    font-size: 16px;
  }

}


@media screen and (max-width: 720px){

  .receta-el{
    width:100%;
    margin-right: 0;
  }

  .receta-el:nth-child(2n){
    margin-left: 0;
  }

  .receta-el:nth-child(3n){
    margin-right: 0px;
  }



}


@media screen and (max-height: 930px){
  
  .ultimas-recetas .receta-el{
    height: 250px;
  }

}

@media screen and (max-height: 880px){
  
  .ultimas-recetas .receta-el{
    height: 200px;
  }

}


</style>



// WEBPACK FOOTER //
// src/components/parts/receta-el.vue